import React, { useState } from 'react';
import './FormPage.css';

// Simple demo page to show customization options
const CustomizationPage = () => {
  const [formStyle, setFormStyle] = useState({
    primaryColor: '#3b82f6',
    borderRadius: '8px',
    buttonColor: '#3b82f6',
    backgroundColor: '#ffffff',
  });
  
  const updateStyle = (key, value) => {
    setFormStyle({
      ...formStyle,
      [key]: value
    });
  };
  
  // Sample form with applied styles
  const DemoForm = () => {
    return (
      <div className="form-container" style={{
        backgroundColor: formStyle.backgroundColor,
        borderRadius: formStyle.borderRadius
      }}>
        <h2 style={{ color: formStyle.primaryColor }}>Customized Form</h2>
        <form>
          <div className="form-field">
            <label style={{ color: formStyle.primaryColor }}>Name</label>
            <input 
              type="text" 
              placeholder="Enter your name"
              style={{ 
                borderRadius: formStyle.borderRadius,
                borderColor: formStyle.primaryColor 
              }}
            />
          </div>
          <div className="form-field">
            <label style={{ color: formStyle.primaryColor }}>Email</label>
            <input 
              type="email" 
              placeholder="Enter your email"
              style={{ 
                borderRadius: formStyle.borderRadius,
                borderColor: formStyle.primaryColor 
              }}
            />
          </div>
          <button 
            type="button" 
            style={{ 
              backgroundColor: formStyle.buttonColor,
              borderRadius: formStyle.borderRadius 
            }}
          >
            Submit
          </button>
        </form>
      </div>
    );
  };
  
  return (
    <div>
      <h1 className="page-title">Form Customization</h1>
      
      <div className="page-description">
        <p>This page demonstrates how forms can be customized with different styles and appearance options.</p>
      </div>
      
      <div className="form-options">
        <div className="option-group">
          <label>Primary Color:</label>
          <input
            type="color"
            value={formStyle.primaryColor}
            onChange={(e) => updateStyle('primaryColor', e.target.value)}
          />
        </div>
        
        <div className="option-group">
          <label>Button Color:</label>
          <input
            type="color"
            value={formStyle.buttonColor}
            onChange={(e) => updateStyle('buttonColor', e.target.value)}
          />
        </div>
        
        <div className="option-group">
          <label>Background Color:</label>
          <input
            type="color"
            value={formStyle.backgroundColor}
            onChange={(e) => updateStyle('backgroundColor', e.target.value)}
          />
        </div>
        
        <div className="option-group">
          <label>Border Radius:</label>
          <select
            value={formStyle.borderRadius}
            onChange={(e) => updateStyle('borderRadius', e.target.value)}
          >
            <option value="0">Sharp (0px)</option>
            <option value="4px">Slight (4px)</option>
            <option value="8px">Rounded (8px)</option>
            <option value="16px">Very Rounded (16px)</option>
            <option value="24px">Pill (24px)</option>
          </select>
        </div>
      </div>
      
      <div className="code-example">
        <h3>Example Configuration:</h3>
        <pre>{`
// Form Style Configuration
{
  primaryColor: "${formStyle.primaryColor}",
  buttonColor: "${formStyle.buttonColor}",
  backgroundColor: "${formStyle.backgroundColor}",
  borderRadius: "${formStyle.borderRadius}"
}
        `}</pre>
      </div>
      
      <div className="form-container-wrapper">
        <DemoForm />
      </div>
    </div>
  );
};

export default CustomizationPage; 